export default {
    resetSetItem (key, newVal) {
        let newStorageEvent = document.createEvent('StorageEvent');
        const storage = {
            setItem: function (k, val) {
                localStorage.setItem(k, val);
                // 初始化创建的事件
                newStorageEvent.initStorageEvent('setItem', false, false, k, null, val, null, null);
                // 派发对象
                window.dispatchEvent(newStorageEvent)
            }
        }
        return storage.setItem(key, newVal);
    },
    getUserInfo () {
        let m = {};
        try {
            m = JSON.parse(localStorage.getItem('USER_INFO'));
        } catch (e) {}
        return m;
    },
    setUserInfo (map) {
        try {
            m = JSON.parse(localStorage.getItem('USER_INFO'));
            let mm = Object.assign({}, m, map);
            // localStorage.setItem('USER_INFO', JSON.stringify(mm));
            this.resetSetItem('USER_INFO', JSON.stringify(mm));
        } catch (e) {
            // localStorage.setItem('USER_INFO', JSON.stringify(map));
            this.resetSetItem('USER_INFO', JSON.stringify(map));
        }
    },
    scroll (event, fn) {
        let div = event.target;
        if (this.getScrollTop(div) + this.getClientHeight(div) >= this.getScrollHeight(div) - 20) {
            if (typeof fn === 'function') {
                fn.call();
            }
        }
    },
    stripscript (value) {
        return value.toString().replace(/[`~!@#$^&*()=|{}';',\[\].<>/?~！@#￥……&*（）——|{}【】‘；：”“'。，、？]/g, '');
    },
    getScrollTop (dom) {
        return dom.scrollTop;
    },
    getClientHeight (dom) {
        return dom.clientHeight;
    },
    getScrollHeight (dom) {
        return dom.scrollHeight;
    },
    changeListMap (obj, value, label) {
        let map = {};
        let list = [];
        value = value || 'value';
        label = label || 'label';
        if (this.typeOf(obj) === 'array') {
            obj.forEach(v => {
                map[v[value]] = v[label];
            });
            return map;
        } else if (this.typeOf(obj) === 'object') {
            for (let k in obj) {
                let m = {};
                m[value] = k;
                m[label] = obj[k];
                list.push(m);
            }
            return list;
        }
        return [];
    },
    setCookie (key, value, day) {
        let date = new Date();
        date.setTime(date.getTime() + (day * 24 * 60 * 60 * 1000));
        let expires = `expires=${date.toUTCString()}`;
        document.cookie = `${key}=${value}; ${expires}`;
    },
    isIdCard (value) {
        value = String(value);
        if (value.length !== 18) {
            return false;
        }
        value = value.toUpperCase();
        let l1 = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
        let l2 = ['1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2'];
        let sigma = 0;
        for (let i = 0; i < 17; i++) {
            let b = value[i];
            let w = l1[i];
            sigma += b * w;
        }
        let sNumber = sigma % 11;
        let checkNumber = l2[sNumber];
        if (value[17] === checkNumber) {
            return true;
        } else {
            return false;
        }
    },
    dataURLtoFile (dataurl, filename) {
        let arr = dataurl.split(',');
        let mime = arr[0].match(/:(.*?);/)[1];
        let bstr = atob(arr[1]);
        let n = bstr.length;
        let u8arr = new Uint8Array(n);
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }
        return new File([u8arr], filename, { type: mime });
    },
    getUrlKeyValue (key) {
        let href = location.href;
        let reg = new RegExp(`${key}=([^&]*)`);
        return href.match(reg) && href.match(reg)[1] ? href.match(reg)[1] : '';
    },
    isPhone () {
        return /Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent);
    },
    getCookie (key) {
        let cookie = document.cookie;
        let reg = new RegExp(`${key}=([^;]*)`);
        return cookie.match(reg) && cookie.match(reg)[1] ? cookie.match(reg)[1] : '';
    },
    param (obj) {
        let str = '';
        for (let k in obj) {
            str += str === '' ? k + '=' + obj[k] : ('&' + k + '=' + obj[k]);
        }
        return str;
    },
    speckText (str, type) {
        const s = str || '';

        const t = type || 'en';

        let url = 'http://tts.baidu.com/text2audio?lan=' + t + '&spd=4&ie=UTF-8&text=' + encodeURI(s);

        let n = new Audio(url);

        n.src = url;

        s && n.play();
    },
    getTextLen (text, fontSize) {
        let total = 0
            ;
        text = (text == null ? '' : text).toString();
        for (let i = 0; i < text.length; i++) {
            let len = text.charCodeAt(i) < 255 ? 1 : 2;
            total += len;
        }
        if (fontSize != null) {
            total = this.getTextWidth(text, fontSize);
        }
        return total;
    },
    getTextWidth (text, fontSize) {
        let total = 0;
        let size = fontSize || 12;
        let t = text ? text.toString() : '';

        for (let i = 0; i < text.length; i++) {
            total += this.getCharWidth(t.charAt(i), size);
        }

        return total;
    },
    getCharWidth (c, fontSize) {
        let len = c.charCodeAt(0) < 255 ? 1 : 2;
        let charWidth = '';
        ;

        fontSize = fontSize == null ? 12 : fontSize;
        charWidth = [fontSize * 1.201 / 2, fontSize * 1.002];

        switch (fontSize) {
            case 12:
                charWidth[0] = fontSize * 1.17 / 2;
                break; case 13:
                charWidth[0] = fontSize * 1.232 / 2;
                break; case 14:
                charWidth[0] = fontSize * 1.146 / 2;
                break; case 15:
                charWidth[0] = fontSize * 1.201 / 2;
        }

        return charWidth[len - 1];
    },
    typeOf (o) {
        return Object.prototype.toString.call(o).match(/ ([^\]]+)/i)[1].toLowerCase();
    },
    clone (o) {
        let clone = (o) => {
            let type = this.typeOf(o);
            if (['number', 'string', 'boolean', 'null', 'undefined', 'regexp'].indexOf(type) > -1) {
                return o;
            } else if (type === 'array') {
                let t = [];
                for (let i = 0, l = o.length; i < l; i++) {
                    t.push(clone(o[i]));
                }
                return t;
            } else {
                let t = {};
                for (let k in o) {
                    t[k] = clone(o[k]);
                }
                return t;
            }
        };
        return clone(o);
    },
    isInnerIPFn () {
        // 获取当前页面url
        let curPageUrl = window.location.href;
        console.log('curPageUrl-0  ' + curPageUrl);

        let reg1 = /(http|ftp|https|www):\/\//g;
        curPageUrl = curPageUrl.replace(reg1, '');
        // console.log('curPageUrl-1  '+curPageUrl);
        let reg2 = /\:+/g;// eslint-disable-line
        curPageUrl = curPageUrl.replace(reg2, '.');
        // console.log('curPageUrl-2  '+curPageUrl);

        curPageUrl = curPageUrl.split('.');
        console.log(curPageUrl);

        let ipAddress = curPageUrl[0] + '.' + curPageUrl[1] + '.' + curPageUrl[2] + '.' + curPageUrl[3];

        let isInnerIp = false;
        let ipNum = this.getIpNum(ipAddress);
        let aBegin = this.getIpNum('10.0.0.0');
        let aEnd = this.getIpNum('10.255.255.255');
        let bBegin = this.getIpNum('172.16.0.0');
        let bEnd = this.getIpNum('172.31.255.255');
        let cBegin = this.getIpNum('192.168.0.0');
        let cEnd = this.getIpNum('192.168.255.255');
        let dBegin = this.getIpNum('127.0.0.0');
        let dEnd = this.getIpNum('127.255.255.255');
        isInnerIp = this.isInner(ipNum, aBegin, aEnd) || this.isInner(ipNum, bBegin, bEnd) || this.isInner(ipNum, cBegin, cEnd) || this.isInner(ipNum, dBegin, dEnd);
        console.log('是否是内网:' + isInnerIp);
        return isInnerIp;
    },
    getIpNum (ipAddress) {
        let ip = ipAddress.split('.');
        let a = parseInt(ip[0]);
        let b = parseInt(ip[1]);
        let c = parseInt(ip[2]);
        let d = parseInt(ip[3]);
        let ipNum = a * 256 * 256 * 256 + b * 256 * 256 + c * 256 + d;
        return ipNum;
    },
    isInner (userIp, begin, end) {
        return (userIp >= begin) && (userIp <= end);
    },
    // ↓↓↓格式化数字：9，999（数字每隔三位加一个逗号）
    formatNum: (num) => {
        var num = (num || 0).toString();
        let result = '';
        while (num.length > 3) {
            result = ',' + num.slice(-3) + result;
            num = num.slice(0, num.length - 3);
        }
        if (num) {
            result = num + result;
        }
        return result;
    },
    setTimeFormat (str) {
        if (!str) return '';
        return str.slice(0, 4) + '-' + str.slice(4, 6) + '' + str.slice(6, 8);
    },
    getComponentInstance (routerName, vue) {
        let map = {
            componentInstance: {},
            key: '',
            vue: null
        }
        vue.$root.$children[0].$children[0].$children.forEach(v => {
        // vue.$root._vnode.componentInstance.$vnode.componentInstance.$children.forEach(v => {
        // vue.$parent.$parent.$children.forEach(v => {
            // if (v.$vnode.data.staticClass === 'router-view') {
            routerName = routerName.split('?')[0];
            this.setComponentInstance(v, routerName, map);
            // if (routerName === name) {
            //     key = v.$vnode.tag.match(/vue-component-([^-]*)/) && v.$vnode.tag.match(/vue-component-([^-]*)/)[1] ? v.$vnode.tag.match(/vue-component-([^-]*)/)[1] : '';
            //     componentInstance = v.$vnode.parent.componentInstance;
            // }
            // v.$children.forEach(v1 => {
            //     let name = v1._vnode.data.staticClass && v1._vnode.data.staticClass.split('-') ? v1._vnode.data.staticClass.split('-')[0] : '';
            //     routerName = routerName.split('?')[0];
            //     if (routerName === name) {
            //         key = v1.$vnode.tag.match(/vue-component-([^-]*)/) && v1.$vnode.tag.match(/vue-component-([^-]*)/)[1] ? v1.$vnode.tag.match(/vue-component-([^-]*)/)[1] : '';
            //         componentInstance = v1.$vnode.parent.componentInstance;
            //     }
            // });
            // }
        });
        return map;
    },
    setComponentInstance (node, routerName, map) {
        let name = node.$vnode.tag && node.$vnode.tag.split('-') && node.$vnode.tag.split('-')[0] ? node.$vnode.tag.split('-')[node.$vnode.tag.split('-').length - 1] : '';
        if (!name) return;
        routerName = routerName.split('?')[0];
        if (routerName === name && node.$vnode.parent) {
            map.key = node.$vnode.tag.match(/vue-component-([^-]*)/) && node.$vnode.tag.match(/vue-component-([^-]*)/)[1] ? node.$vnode.tag.match(/vue-component-([^-]*)/)[1] : '';
            map.componentInstance = node.$vnode.parent.componentInstance;
            map.vue = node
        }
        if (node.$children && node.$children.length !== 0) {
            node.$children.forEach(v => {
                this.setComponentInstance(v, routerName, map);
            });
        }
    },
    deepProxy (object, handler) {
        if (this.isComplexObject(object)) {
            this.addProxy(object, handler);
        }
        return new Proxy(object, handler);
    },
    isComplexObject (object) {
        if (typeof object !== 'object') {
            return false;
        } else {
            for (let prop in object) {
                if (typeof object[prop] === 'object') {
                    return true;
                }
            }
        }
        return false;
    },
    addProxy (obj, handler) {
        for (let i in obj) {
            if (typeof obj[i] === 'object') {
                if (isComplexObject(obj[i])) {
                    addProxy(obj[i], handler);
                }
                obj[i] = new Proxy(obj[i], handler);
            }
        }
    }
};
